import React, { createContext, useContext, useState } from "react";
import { ERROR, LOADING, SUCCESS } from "../constants/common";
import { ReactComponent as WarningIcon } from "../assets/Icons/warning.svg";
import {
  getUserProfile,
  sendToFriend,
  getMemberList,
} from "../services/userProfile.services";
import { useAlert } from "./Alert";
import { suppressAlertPaths } from "../constants/lists";
import { useLocation } from "react-router-dom";

const UserProfileContext = createContext({});

export const UserProfileContextProvider = ({ children }) => {
  const { sendAlert } = useAlert();
  const location = useLocation();

  const [userProfileState, setUserProfileState] = useState({
    data: {},
    fetchStatus: "",
    likeStatus: "",
    sendToFriendStatus: "",
  });

  function handleState(obj) {
    setUserProfileState((prevState) => ({
      ...prevState,
      ...obj,
    }));
  }

  async function fetchUserProfile(data) {
    handleState({ fetchStatus: LOADING });
    try {
      const response = await getUserProfile(data);
      const memberResponse =
        data?.account_type === "treatment_program"
          ? await getMemberList({
              treatment_id: response?.data?.data?.info?.id,
              account_type: data.user_account_type,
            })
          : null;
      handleState({
        data: {
          ...response.data.data,
          membersList: memberResponse?.data?.data?.data || null,
        },
        fetchStatus: SUCCESS,
      });
    } catch (error) {
      handleState({ fetchStatus: ERROR });
      const showAlert = !suppressAlertPaths.some((path) =>
        location.pathname.startsWith(path)
      );
      if (showAlert) {
        sendAlert(error.response?.data?.message, "error");
      }
      Promise.reject(error);
    }
  }

  async function sendEmailToFriend(data) {
    handleState({ sendToFriendStatus: LOADING });
    try {
      const response = await sendToFriend(data);
      if (response.data?.type === "warning") {
        sendAlert(response.data?.data?.message, "warning", true, null, WarningIcon);
        handleState({ sendToFriendStatus: ERROR });
        return;
      }
      handleState({
        sendToFriendStatus: SUCCESS,
      });
      sendAlert(
        "You’ve successfully shared this provider’s information.",
        "success"
      );
    } catch (error) {
      handleState({ sendToFriendStatus: ERROR });
      sendAlert(error.response?.data?.message, "error");
      Promise.reject(error);
    }
  }

  function updateUserProfileState(field, value) {
    handleState({ [field]: value });
  }

  const state = {
    ...userProfileState,
    fetchUserProfile,
    sendEmailToFriend,
    updateUserProfileState,
  };

  return (
    <UserProfileContext.Provider value={state}>
      {children}
    </UserProfileContext.Provider>
  );
};

export const useUserProfile = () => useContext(UserProfileContext);
